import type { ConnectorPropertiesSchema, FilteredDataSources } from "shared-ui";
import { getAccountingConnectors } from "shared-ui";
import type { FundingApplicationSchemas } from "api-types";

/**
 * Only "codat_file_uploads" and "codat_accounting" (platforms connected via codat) are excluded
 */
export const getFilteredAccountingConnectors = (connectors: FilteredDataSources) => {
  return getAccountingConnectors(connectors).filter(
    (connector) => connector.slug !== "codat_file_uploads" && connector.slug !== "codat_accounting"
  );
};

export const filterConnectorsByStageConfig = (
  connectors: ConnectorPropertiesSchema[],
  stageData?:
    | FundingApplicationSchemas.RevenueStageDataScreen
    | FundingApplicationSchemas.MarketingStageDataScreen
    | FundingApplicationSchemas.AccountingStageDataScreen
    | null
): ConnectorPropertiesSchema[] => {
  // If no stage config, allow all connectors
  if (!stageData) {
    return connectors;
  }

  // If allowedPlatformSelectionSlugs is null/undefined, no filter so allow all
  if (stageData.allowedPlatformSelectionSlugs === null || stageData.allowedPlatformSelectionSlugs === undefined) {
    return connectors;
  }

  // Filter down to allowed or required slugs
  return connectors.filter((connector) => {
    return (
      stageData.allowedPlatformSelectionSlugs?.includes(connector.slug) ||
      stageData.requiredConnectorSlugs?.includes(connector.slug)
    );
  });
};
